module.exports = __webpack_public_path__ + "img/graph_title_sp.8fd2c12.svg";